import React, { useEffect, useState } from "react";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import ObDetailsApi from "../../services/api/ObDetails";
import { Box } from "@mui/material";
import { getPath, isValNull } from "../../utils";
import { Call,InfoLine } from "sushiweb/Icons";
import Toast from "sushiweb/Toast";
import Button from "sushiweb/Button";
import FiltersModal from "../../components/Common/FiltersModal";
import PaginatedReactDropdown from "../../components/Common/PaginatedReactDropdown";
import CallLogsModal from "../../components/LifeLine/OrderInfo/CallLogsModal"
import { colors } from "@material-ui/core";


const OnboardingDetails = () => {
  const [showModal, setShowModal] = useState(false);
  const [obDetails, setObDetails] = useState(null);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [rateCardFiltersSheet, setRateCardFiltersSheet] = useState(false);
  const [submitted, setsubmitted] = React.useState(false);
  const [numberOfSelectedFilters, setNumberOfSelectedFilters] = useState(0);
  const [modalContent, setModalContent] = useState("");
  const [activeRateCardFilters, setActiveRateCardFilters] = useState({
    city_id: "",
    zone_id: "",
    city_name: "",
    zone_name: "",
  });

  useEffect(() => {
    let count = 0;
    if (activeRateCardFilters.city_id) {
      count++;
    }
    if (activeRateCardFilters.zone_id) {
      count++;
    }
    setNumberOfSelectedFilters(count);
  }, [activeRateCardFilters]);

  const [toastData, setToastData] = useState({
    show: false,
    text: "",
    type: "",
  });
  const [initialState, setInitialState] = React.useState({
    filterType: "ob_id",
    filterValue: "",
    filterCityId: "",
    filterCityName: "",
    filterZoneId: "",
    filterZoneName: "",
  });

  const handleChange = (key, value) => {
    setInitialState((prevState) => {
      return { ...prevState, [key]: value };
    });
  };

  const handleFiltersClick = () => {
    setRateCardFiltersSheet(!rateCardFiltersSheet);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setsubmitted(true);
    let values = { ...initialState };
    values.filterCityId = activeRateCardFilters.city_id;
    values.filterZoneId = activeRateCardFilters.zone_id;
    values.filterCityName = activeRateCardFilters.city_name;
    values.filterZoneName = activeRateCardFilters.zone_name;
    setInitialState(values);
  };

  const Filters = [
    { key: "ob_id", label: "Driver Onboading ID" },
    { key: "lead_id", label: "Lead ID" },
    { key: "driver_id", label: "Driver ID"},
  ];

  useEffect(() => {
    if (submitted && initialState.filterType && initialState.filterValue) {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }

      const newTimeout = setTimeout(async () => {
        try {
          setObDetails(null);
          // Construct query params based on available ID
          const queryParams = [
            `${initialState.filterType}=${initialState.filterValue}`,
            initialState.filterCityId !== "0" && initialState.filterCityId
              ? `city_id=${initialState.filterCityId}`
              : "",
            initialState.filterZoneId !== "0" && initialState.filterZoneId
              ? `zone_id=${initialState.filterZoneId}`
              : "",
          ]
            .filter(Boolean)
            .join("&");

          const response = await ObDetailsApi.getObDetails(queryParams);
          if (response) {
            setObDetails(response);
          }
        } catch (err) {
          console.log("error fetching OB details:", err);
        }
      }, 500);
      setsubmitted(false);
      setDebounceTimeout(newTimeout);
    }
  }, [submitted]);

  const closeToast = () => {
    setToastData({
      show: false,
      text: "",
      type: "",
    });
  };

  const getInputLabel = (val, options, fromKey, toKey) => {
    const activeEle = options.find((item) => {
      return item[fromKey] === val;
    });
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  const handleCallIconClick = async () => {
    if (obDetails?.ob_id || obDetails?.lead_data) {
      try {
        // Call API to initiate the outgoing call using the OB ID
        let body = obDetails?.ob_id
          ? { ob_id: obDetails.ob_id }
          : { lead_id: obDetails.lead_data.lead_id };
        const response = await ObDetailsApi.connectOutGoingCall(body);
        setToastData({
          show: true,
          text: getPath(response, "message", "Call initiated successfully!"),
          type: "success",
        });
      } catch (err) {
        setToastData({
          show: true,
          text: "error in initiating call!",
          type: "error",
        });
      }
    }
  };

  const handleCallLogsClick = async () => {
    if (obDetails?.ob_id || obDetails?.lead_data) {
      try {
        const queryParams = [
          `${initialState.filterType}=${initialState.filterValue}`,
          initialState.filterCityId !== "0" && initialState.filterCityId
            ? `city_id=${initialState.filterCityId}`
            : "",
          initialState.filterZoneId !== "0" && initialState.filterZoneId
            ? `zone_id=${initialState.filterZoneId}`
            : "",
        ]
          .filter(Boolean)
          .join("&");
        const response = await ObDetailsApi.getObCallLogs(queryParams);
        if (response) {
          setToastData({
            show: true,
            text: getPath(response, "message", "Call logs fetched successfully!"),
            type: "success",
          });
          setModalContent(response);
          setShowModal(true);
        }
      } catch (err) {
        setToastData({
          show: true,
          text: "Error while retrieving call logs",
          type: "error",
        });
      }
    }
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const navigateToQcDetails = () => {
    if (obDetails?.driver_id) {
      window.open(`/qc-details-v2/${obDetails.driver_id}`, '_blank');
    }
  };


  return (
    <div>
      <Heading>Onboarding Details</Heading>
      <div style={{ width: "100%" }}>
        <FlexContainer className="mb-10" align="flex-start" justify="center">
          <PaginatedReactDropdown
            options={Filters}
            data-testid="FilterTypeDropDown"
            placeholder=""
            value={getInputLabel(
              initialState.filterType,
              Filters,
              "key",
              "label"
            )}
            handleChange={handleChange}
            keyToChange="filterType"
            showCross={false}
            id="FilterTypeDropDown"
            width="20%"
            labelKey="label"
            valueKey="key"
          />
          <div
            style={{
              width: "40%",
            }}
          >
            <Input
              value={initialState.filterValue}
              data-testid="filterInput"
              id="sushi-input"
              onChange={(e) => handleChange("filterValue", e)}
              width={"50%"}
            />
          </div>
          <div>
            <Button
              data-testid="submitButton"
              className="sushi-btn"
              onClick={handleFiltersClick}
            >
              <span>
                Rate Card Filters{" "}
                {numberOfSelectedFilters != 0
                  ? "(" + numberOfSelectedFilters + ")"
                  : ""}{" "}
              </span>
            </Button>
          </div>
          <div style={{ marginLeft: "10px" }}>
            <Button
              data-testid="submitButton"
              className="sushi-btn"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </FlexContainer>
        <div>
          {rateCardFiltersSheet && (
            <FiltersModal
              cityFilters={true}
              zoneFilters={true}
              modalState={rateCardFiltersSheet}
              handleClose={() => {
                setRateCardFiltersSheet(false);
              }}
              activeFilters={activeRateCardFilters}
              updateActiveFilters={setActiveRateCardFilters}
              modalHeading={"Rate Card Filters"}
            />
          )}
        </div>
      </div>
      <FlexContainer
        align="flex-start"
        style={{
          flexDirection: "column",
          gap: "20px",
          padding: "20px",
          backgroundColor: "#f9f9f9",
        }}
      >
        {(obDetails?.ob_id || obDetails?.lead_data) && (
          <>
            <Box style={{ width: "100%", padding: "20px" }}>
              <Box style={{ width: "100%" }}>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingBottom: "10px",
                  }}
                >
                <Button
                  data-testid="obCallBtn"
                  className="sushi-btn"
                  onClick={handleCallIconClick}
                >
                  <span style={{ display: "inline-flex", alignItems: "center" }}>
                    Call the DP: <Call style={{ cursor: "pointer", marginLeft: "5px" }} color="white"  />
                  </span>
                  
                </Button>

                <Button
                  data-testid="obCallBtn"
                  className="sushi-btn"
                  onClick={handleCallLogsClick}
                >
                  <span style={{ display: "inline-flex", alignItems: "center" }}>
                    Call Logs: <InfoLine style={{ cursor: "pointer", marginLeft: "5px"}} color="white"/>
                  </span>
                  
                </Button>
                </Box>
                {toastData.show && (
                  <Toast
                    show={true}
                    align="top"
                    onClose={closeToast}
                    text={toastData.text}
                    type={toastData.type}
                    autoHideDuration={2}
                  />
                )}
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    margin: "10px 0",
                    border: "1px solid #ddd",
                  }}
                >
                  <tbody>
                    {obDetails?.ob_id && (
                      <tr>
                        <td style={tableKeyStyle}>OB ID:</td>
                        <td style={tableValueStyle}>{obDetails.ob_id}</td>
                      </tr>
                    )}
                    {obDetails?.driver_id && (
                        <tr>
                          <td style={tableKeyStyle}>Driver ID:</td>
                          <td style={tableValueStyle}>
                            {obDetails.driver_id}{" "}
                            <span
                                onClick={navigateToQcDetails}
                                style={{color: 'blue', cursor: 'pointer', textDecoration: 'underline'}}
                            >
                              (View QC Details)
                            </span>
                          </td>
                        </tr>
                    )}
                    {obDetails?.login_city && (
                      <tr>
                        <td style={tableKeyStyle}>Login City:</td>
                        <td style={tableValueStyle}>{obDetails.login_city}</td>
                      </tr>
                    )}
                    {obDetails?.onboarding_date && (
                      <tr>
                        <td style={tableKeyStyle}>Created Date:</td>
                        <td style={tableValueStyle}>
                          {obDetails.onboarding_date}
                        </td>
                      </tr>
                    )}
                    {obDetails?.onboarding_app_type && (
                      <tr>
                        <td style={tableKeyStyle}>Onboarding App Type:</td>
                        <td style={tableValueStyle}>
                          {obDetails.onboarding_app_type}
                        </td>
                      </tr>
                    )}
                    {obDetails?.onboarding_flow && (
                      <tr>
                        <td style={tableKeyStyle}>Onboarding Flow:</td>
                        <td style={tableValueStyle}>
                          {obDetails.onboarding_flow}
                        </td>
                      </tr>
                    )}
                    {obDetails?.app_version && (
                      <tr>
                        <td style={tableKeyStyle}>App Version:</td>
                        <td style={tableValueStyle}>{obDetails.app_version}</td>
                      </tr>
                    )}
                    {obDetails?.current_section && (
                      <tr>
                        <td style={tableKeyStyle}>Current Section:</td>
                        <td style={tableValueStyle}>
                          {obDetails.current_section}
                        </td>
                      </tr>
                    )}
                    {obDetails?.lead_source && (
                      <tr>
                        <td style={tableKeyStyle}>Lead Source:</td>
                        <td style={tableValueStyle}>{obDetails.lead_source}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Box>

              {obDetails?.lead_data && (
                <Box style={{ width: "100%" }}>
                  <Box style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                    Lead Details:
                  </Box>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      margin: "10px 0",
                      border: "1px solid #ddd",
                    }}
                  >
                    <tbody>
                      {obDetails?.lead_data?.lead_id && (
                        <tr>
                          <td style={tableKeyStyle}>Lead ID:</td>
                          <td style={tableValueStyle}>
                            {obDetails.lead_data.lead_id}
                          </td>
                        </tr>
                      )}
                      {obDetails?.lead_data?.channel && (
                        <tr>
                          <td style={tableKeyStyle}>Channel:</td>
                          <td style={tableValueStyle}>
                            {obDetails.lead_data.channel}
                          </td>
                        </tr>
                      )}
                      {obDetails?.lead_data?.source && (
                        <tr>
                          <td style={tableKeyStyle}>Source:</td>
                          <td style={tableValueStyle}>
                            {obDetails.lead_data.source}
                          </td>
                        </tr>
                      )}
                      {obDetails?.lead_data?.name && (
                        <tr>
                          <td style={tableKeyStyle}>Name:</td>
                          <td style={tableValueStyle}>
                            {obDetails.lead_data.name}
                          </td>
                        </tr>
                      )}
                      {obDetails?.lead_data?.lead_created_date && (
                        <tr>
                          <td style={tableKeyStyle}>Created Date:</td>
                          <td style={tableValueStyle}>
                            {obDetails.lead_data.lead_created_date}
                          </td>
                        </tr>
                      )}
                      {obDetails?.lead_data?.city && (
                        <tr>
                          <td style={tableKeyStyle}>City:</td>
                          <td style={tableValueStyle}>
                            {obDetails.lead_data.city}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Box>
              )}

              {obDetails?.locality_details && (
                <Box style={{ width: "100%" }}>
                  <Box style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                    Address Information:
                  </Box>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      margin: "10px 0",
                      border: "1px solid #ddd",
                    }}
                  >
                    <tbody>
                      {obDetails?.locality_details?.locality && (
                        <tr>
                          <td style={tableKeyStyle}>Locality:</td>
                          <td style={tableValueStyle}>
                            {obDetails.locality_details.locality}
                          </td>
                        </tr>
                      )}
                      {obDetails?.locality_details?.city && (
                        <tr>
                          <td style={tableKeyStyle}>City:</td>
                          <td style={tableValueStyle}>
                            {obDetails.locality_details.city}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Box>
              )}

              {obDetails?.aadhaar_details && (
                <Box style={{ width: "100%" }}>
                  <Box style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                    Aadhaar Details:
                  </Box>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      margin: "10px 0",
                      border: "1px solid #ddd",
                    }}
                  >
                    <tbody>
                      {obDetails?.aadhaar_details?.aadhaar_no && (
                        <tr>
                          <td style={tableKeyStyle}>Aadhaar No:</td>
                          <td style={tableValueStyle}>
                            {obDetails.aadhaar_details.aadhaar_no}
                          </td>
                        </tr>
                      )}
                      {obDetails?.aadhaar_details?.verification_status && (
                        <tr>
                          <td style={tableKeyStyle}>Verification Status:</td>
                          <td style={tableValueStyle}>
                            {obDetails.aadhaar_details.verification_status}
                          </td>
                        </tr>
                      )}
                      {obDetails?.aadhaar_details?.attempts && (
                        <tr>
                          <td style={tableKeyStyle}>Attempts:</td>
                          <td style={tableValueStyle}>
                            {obDetails.aadhaar_details.attempts}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Box>
              )}

              {obDetails?.pan_details && (
                <Box style={{ width: "100%" }}>
                  <Box style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                    PAN Details:
                  </Box>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      margin: "10px 0",
                      border: "1px solid #ddd",
                    }}
                  >
                    <tbody>
                      {obDetails?.pan_details?.pan_no && (
                        <tr>
                          <td style={tableKeyStyle}>PAN No:</td>
                          <td style={tableValueStyle}>
                            {obDetails.pan_details.pan_no}
                          </td>
                        </tr>
                      )}
                      {obDetails?.pan_details?.name && (
                        <tr>
                          <td style={tableKeyStyle}>Name:</td>
                          <td style={tableValueStyle}>
                            {obDetails.pan_details.name}
                          </td>
                        </tr>
                      )}
                      {obDetails?.pan_details?.verification_status && (
                        <tr>
                          <td style={tableKeyStyle}>Verification Status:</td>
                          <td style={tableValueStyle}>
                            {obDetails.pan_details.verification_status}
                          </td>
                        </tr>
                      )}
                      {obDetails?.pan_details?.pan_aadhaar_linked !==
                        undefined && (
                        <tr>
                          <td style={tableKeyStyle}>Pan And Aadhaar Linked:</td>
                          <td style={tableValueStyle}>
                            {obDetails.pan_details.pan_aadhaar_linked
                              ? "Yes"
                              : "No"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Box>
              )}

              {obDetails?.personal_details && (
                <Box style={{ width: "100%" }}>
                  <Box style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                    Personal Information:
                  </Box>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      margin: "10px 0",
                      border: "1px solid #ddd",
                    }}
                  >
                    <tbody>
                      {obDetails?.personal_details?.name && (
                        <tr>
                          <td style={tableKeyStyle}>Name:</td>
                          <td style={tableValueStyle}>
                            {obDetails.personal_details.name}
                          </td>
                        </tr>
                      )}
                      {obDetails?.personal_details?.fathers_name && (
                        <tr>
                          <td style={tableKeyStyle}>Father's Name:</td>
                          <td style={tableValueStyle}>
                            {obDetails.personal_details.fathers_name}
                          </td>
                        </tr>
                      )}
                      {obDetails?.personal_details?.dob && (
                        <tr>
                          <td style={tableKeyStyle}>DOB:</td>
                          <td style={tableValueStyle}>
                            {obDetails.personal_details.dob}
                          </td>
                        </tr>
                      )}
                      {obDetails?.personal_details?.sex && (
                        <tr>
                          <td style={tableKeyStyle}>Sex:</td>
                          <td style={tableValueStyle}>
                            {obDetails.personal_details.sex}
                          </td>
                        </tr>
                      )}
                      {obDetails?.personal_details?.current_address && (
                        <tr>
                          <td style={tableKeyStyle}>Current Address:</td>
                          <td style={tableValueStyle}>
                            {obDetails.personal_details.current_address}
                          </td>
                        </tr>
                      )}
                      {obDetails?.personal_details?.permanent_address && (
                        <tr>
                          <td style={tableKeyStyle}>Permanent Address:</td>
                          <td style={tableValueStyle}>
                            {obDetails.personal_details.permanent_address}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Box>
              )}

              {obDetails?.carrier_details && (
                <Box style={{ width: "100%" }}>
                  <Box style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                    Carrier Information:
                  </Box>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      margin: "10px 0",
                      border: "1px solid #ddd",
                    }}
                  >
                    <tbody>
                      {obDetails?.carrier_details?.type && (
                        <tr>
                          <td style={tableKeyStyle}>Carrier Type:</td>
                          <td style={tableValueStyle}>
                            {obDetails.carrier_details.type}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Box>
              )}

              {obDetails?.payment_details && (
                <Box style={{ width: "100%" }}>
                  <Box style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                    Payment Details:
                  </Box>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      margin: "10px 0",
                      border: "1px solid #ddd",
                    }}
                  >
                    <tbody>
                      {
                        <tr>
                          <td style={tableKeyStyle}>Security Amount:</td>
                          <td style={tableValueStyle}>
                            {obDetails.payment_details.security_amount}
                          </td>
                        </tr>
                      }
                      {
                        <tr>
                          <td style={tableKeyStyle}>OB Fee Payment Type:</td>
                          <td style={tableValueStyle}>
                            {obDetails.payment_details.ob_fee_payment_type}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </Box>
              )}

              {obDetails?.bonus_details && (
                <Box style={{ width: "100%" }}>
                  <Box style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                    Bonus Details:
                  </Box>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      margin: "10px 0",
                      border: "1px solid #ddd",
                    }}
                  >
                    <tbody>
                      {obDetails?.bonus_details?.joining_bonus && (
                        <tr>
                          <td style={tableKeyStyle}>Joining Bonus:</td>
                          <td style={tableValueStyle}>
                            {obDetails.bonus_details.joining_bonus}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Box>
              )}

              {obDetails?.rate_card_details && (
                <Box style={{ width: "100%" }}>
                  <Box style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                    Rate Card Details:
                  </Box>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      margin: "10px 0",
                      border: "1px solid #ddd",
                    }}
                  >
                    <tbody>
                      {obDetails?.rate_card_details?.ob_packages_applicable !==
                        undefined && (
                        <tr>
                          <td style={tableKeyStyle}>
                            Onboarding Packages Applicable:
                          </td>
                          <td style={tableValueStyle}>
                            {obDetails.rate_card_details.ob_packages_applicable
                              ? "Yes"
                              : "No"}
                          </td>
                        </tr>
                      )}

                      {/* One-Time Construct */}
                      {obDetails?.rate_card_details?.one_time_construct && (
                        <Box style={{ paddingLeft: "20px" }}>
                          {" "}
                          {/* Added paddingLeft to move right */}
                          <Box
                            style={{
                              paddingBottom: "10px",
                              paddingTop: "10px",
                            }}
                          >
                            One Time Construct:
                          </Box>
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              margin: "10px 0",
                              border: "1px solid #ddd",
                            }}
                          >
                            <tbody>
                              {obDetails?.rate_card_details?.one_time_construct
                                ?.total_fee !== undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>Total Fee:</td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .one_time_construct.total_fee
                                    }
                                  </td>
                                </tr>
                              )}
                              {obDetails?.rate_card_details?.one_time_construct
                                ?.one_time_fee !== undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>One Time Fee:</td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .one_time_construct.one_time_fee
                                    }
                                  </td>
                                </tr>
                              )}
                              {obDetails?.rate_card_details?.one_time_construct
                                ?.onboarding_fee !== undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>Onboarding Fee:</td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .one_time_construct.onboarding_fee
                                    }
                                  </td>
                                </tr>
                              )}
                              {obDetails?.rate_card_details?.one_time_construct
                                ?.discount !== undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>Discount:</td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .one_time_construct.discount
                                    }
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </Box>
                      )}

                      {/* Installment Construct */}
                      {obDetails?.rate_card_details?.installment_construct && (
                        <Box style={{ paddingLeft: "20px" }}>
                          {" "}
                          {/* Added paddingLeft to move right */}
                          <Box
                            style={{
                              paddingBottom: "10px",
                              paddingTop: "10px",
                            }}
                          >
                            Installment Construct:
                          </Box>
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              margin: "10px 0",
                              border: "1px solid #ddd",
                            }}
                          >
                            <tbody>
                              {obDetails?.rate_card_details
                                ?.installment_construct?.total_fee !==
                                undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>Total Fee:</td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .installment_construct.total_fee
                                    }
                                  </td>
                                </tr>
                              )}
                              {obDetails?.rate_card_details
                                ?.installment_construct?.onboarding_fee !==
                                undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>Onboarding Fee:</td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .installment_construct.onboarding_fee
                                    }
                                  </td>
                                </tr>
                              )}
                              {obDetails?.rate_card_details
                                ?.installment_construct?.support_fee !==
                                undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>Support Fee:</td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .installment_construct.support_fee
                                    }
                                  </td>
                                </tr>
                              )}
                              {obDetails?.rate_card_details
                                ?.installment_construct?.support_fee_weeks !==
                                undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>
                                    Support Fee Weeks:
                                  </td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .installment_construct.support_fee_weeks
                                    }
                                  </td>
                                </tr>
                              )}
                              {obDetails?.rate_card_details
                                ?.installment_construct?.support_fee_details
                                ?.length > 0 && (
                                <tr>
                                  <td
                                    colSpan={2}
                                    style={{ textAlign: "right" }}
                                  >
                                    <table
                                      style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                        margin: "10px 0",
                                        border: "1px solid #ddd",
                                        textAlign: "center", // Ensures all columns are centered
                                      }}
                                    >
                                      <thead>
                                        <tr>
                                          <th
                                            style={{
                                              ...tableKeyStyle,
                                              textAlign: "center",
                                            }}
                                          >
                                            Deduction Week Number
                                          </th>
                                          <th
                                            style={{
                                              ...tableKeyStyle,
                                              textAlign: "center",
                                            }}
                                          >
                                            Installment Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {obDetails?.rate_card_details?.installment_construct?.support_fee_details?.map(
                                          (detail, index) => (
                                            <tr key={index}>
                                              <td
                                                style={{
                                                  ...tableValueStyle,
                                                  textAlign: "center",
                                                }}
                                              >
                                                {detail.deduction_week_number}
                                              </td>
                                              <td
                                                style={{
                                                  ...tableValueStyle,
                                                  textAlign: "center",
                                                }}
                                              >
                                                {detail.installment_amount}
                                              </td>
                                            </tr>
                                          )
                                        )}
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </Box>
                      )}

                      {/* Percentage Payout Construct */}
                      {obDetails?.rate_card_details
                        ?.percentage_payout_construct && (
                        <Box style={{ paddingLeft: "20px" }}>
                          {" "}
                          {/* Added paddingLeft to move right */}
                          <Box
                            style={{
                              paddingBottom: "10px",
                              paddingTop: "10px",
                            }}
                          >
                            Percentage Payout Construct:
                          </Box>
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              margin: "10px 0",
                              border: "1px solid #ddd",
                            }}
                          >
                            <tbody>
                              {obDetails?.rate_card_details
                                ?.percentage_payout_construct?.total_fee !==
                                undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>Total Fee:</td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .percentage_payout_construct.total_fee
                                    }
                                  </td>
                                </tr>
                              )}
                              {obDetails?.rate_card_details
                                ?.percentage_payout_construct
                                ?.onboarding_fee !== undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>Onboarding Fee:</td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .percentage_payout_construct
                                        .onboarding_fee
                                    }
                                  </td>
                                </tr>
                              )}
                              {obDetails?.rate_card_details
                                ?.percentage_payout_construct?.support_fee !==
                                undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>Support Fee:</td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .percentage_payout_construct.support_fee
                                    }
                                  </td>
                                </tr>
                              )}
                              {obDetails?.rate_card_details
                                ?.percentage_payout_construct
                                ?.payout_percentage !== undefined && (
                                <tr>
                                  <td style={tableKeyStyle}>
                                    Payout Percentage:
                                  </td>
                                  <td style={tableValueStyle}>
                                    {
                                      obDetails.rate_card_details
                                        .percentage_payout_construct
                                        .payout_percentage
                                    }
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </Box>
                      )}

                      {obDetails?.rate_card_details?.saving && (
                        <tr>
                          <td style={tableKeyStyle}>Saving:</td>
                          <td style={tableValueStyle}>
                            {obDetails.rate_card_details.saving}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {obDetails?.rate_card_details?.ob_packages_details?.length >
                    0 && (
                    <Box style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                      Package Details:
                    </Box>
                  )}
                  {obDetails?.rate_card_details?.ob_packages_details?.map(
                    (packageDetail, index) => (
                      <table
                        key={index}
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          margin: "10px 0",
                          border: "1px solid #ddd",
                        }}
                      >
                        <tbody>
                          {packageDetail?.package_type && (
                            <tr>
                              <td style={tableKeyStyle}>Package Type:</td>
                              <td style={tableValueStyle}>
                                {packageDetail.package_type}
                              </td>
                            </tr>
                          )}
                          {packageDetail?.package_name && (
                            <tr>
                              <td style={tableKeyStyle}>Package Name:</td>
                              <td style={tableValueStyle}>
                                {packageDetail.package_name}
                              </td>
                            </tr>
                          )}
                          {packageDetail?.guarantee_amount !== undefined && (
                            <tr>
                              <td style={tableKeyStyle}>Guarantee Amount:</td>
                              <td style={tableValueStyle}>
                                {packageDetail.guarantee_amount}
                              </td>
                            </tr>
                          )}
                          {packageDetail?.total_fee !== undefined && (
                            <tr>
                              <td style={tableKeyStyle}>Total Fee:</td>
                              <td style={tableValueStyle}>
                                {packageDetail.total_fee}
                              </td>
                            </tr>
                          )}
                          {packageDetail?.support_fee !== undefined && (
                            <tr>
                              <td style={tableKeyStyle}>Support Fee:</td>
                              <td style={tableValueStyle}>
                                {packageDetail.support_fee}
                              </td>
                            </tr>
                          )}
                          {packageDetail?.joining_fee !== undefined && (
                            <tr>
                              <td style={tableKeyStyle}>Joining Fee:</td>
                              <td style={tableValueStyle}>
                                {packageDetail.joining_fee}
                              </td>
                            </tr>
                          )}
                          {packageDetail?.period !== undefined && (
                            <tr>
                              <td style={tableKeyStyle}>Period:</td>
                              <td style={tableValueStyle}>
                                {packageDetail.period} days
                              </td>
                            </tr>
                          )}
                          {packageDetail?.min_login_days !== undefined && (
                            <tr>
                              <td style={tableKeyStyle}>Minimum Login Days:</td>
                              <td style={tableValueStyle}>
                                {packageDetail.min_login_days}
                              </td>
                            </tr>
                          )}
                          {packageDetail?.login_hours !== undefined && (
                            <tr>
                              <td style={tableKeyStyle}>
                                Login Hours per Day:
                              </td>
                              <td style={tableValueStyle}>
                                {packageDetail.login_hours}
                              </td>
                            </tr>
                          )}
                          {packageDetail?.validity !== undefined && (
                            <tr>
                              <td style={tableKeyStyle}>Validity:</td>
                              <td style={tableValueStyle}>
                                {packageDetail.validity} days
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )
                  )}
                </Box>
              )}
              <Box style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                Zone Wise Rate Card Details:
              </Box>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  margin: "10px 0",
                  border: "1px solid #ddd",
                }}
              >
                <tbody>
                  {(initialState.filterCityId && (
                    <tr>
                      <td style={tableKeyStyle}>Selected City</td>
                      <td style={tableValueStyle}>
                        {initialState.filterCityName}
                      </td>
                    </tr>
                  )) ||
                    (obDetails?.ob_id && obDetails?.locality_details?.city && (
                      <tr>
                        <td style={tableKeyStyle}>City Selected by lead</td>
                        <td style={tableValueStyle}>
                          {obDetails?.locality_details?.city}
                        </td>
                      </tr>
                    )) ||
                    (obDetails?.lead_data?.city && (
                      <tr>
                        <td style={tableKeyStyle}>Lead city</td>
                        <td style={tableValueStyle}>
                          {obDetails?.lead_data?.city}
                        </td>
                      </tr>
                    ))}
                  {(initialState.filterCityId ||
                    (obDetails?.ob_id && obDetails?.locality_details?.city) ||
                    obDetails?.lead_data?.city) &&
                    initialState.filterZoneId != 0 && (
                      <>
                        <tr>
                          <td style={tableKeyStyle}>Selected Zone</td>
                          <td style={tableValueStyle}>
                            {initialState?.filterZoneName}
                          </td>
                        </tr>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: "20px",
                          }}
                        >
                          <table
                            style={{
                              width: "100%",
                              marginTop: "10px",
                            }}
                          >
                            {obDetails?.zone_list?.zone_name && (
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      fontWeight: "bold",
                                      padding: "8px",
                                      textAlign: "left",
                                      backgroundColor: "#f5f5f5",
                                      border: "1px solid #ddd",
                                    }}
                                    colSpan="2"
                                  >
                                    Zone Name: {obDetails?.zone_list?.zone_name}
                                  </th>
                                </tr>
                              </thead>
                            )}
                            {obDetails?.zone_list?.zone_name && (
                              <tbody>
                                {
                                  <tr>
                                    <td
                                      style={{
                                        fontWeight: "bold",
                                        padding: "8px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      Joining Fee
                                    </td>
                                    <td
                                      style={{
                                        padding: "8px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      {obDetails?.zone_list?.joining_fee || 0}
                                    </td>
                                  </tr>
                                }
                                {
                                  <tr>
                                    <td
                                      style={{
                                        fontWeight: "bold",
                                        padding: "8px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      Joining Bonus
                                    </td>
                                    <td
                                      style={{
                                        padding: "8px",
                                        border: "1px solid #ddd",
                                      }}
                                    >
                                      {obDetails?.joining_bonus_details
                                        ?.bonus_amount || "N/A"}
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            )}
                          </table>
                        </div>
                      </>
                    )}
                  {obDetails?.zone_list?.recommended_zones?.map(
                    (zone, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "20px",
                        }}
                      >
                        <table
                          style={{
                            width: "100%",
                            marginTop: "10px",
                          }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  fontWeight: "bold",
                                  padding: "8px",
                                  textAlign: "left",
                                  backgroundColor: "#f5f5f5",
                                  border: "1px solid #ddd",
                                }}
                                colSpan="2"
                              >
                                Zone Name: {zone?.zone_name}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              <tr>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    padding: "8px",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  Joining Fee
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {zone?.joining_fee || 0}
                                </td>
                              </tr>
                            }
                            {
                              <tr>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    padding: "8px",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  Joining Bonus
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  {zone?.joining_bonus_details?.bonus_amount ||
                                    "N/A"}
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    )
                  )}
                  {obDetails?.zone_list?.other_zones?.map((zone, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "20px",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                          marginTop: "10px",
                        }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                fontWeight: "bold",
                                padding: "8px",
                                textAlign: "left",
                                backgroundColor: "#f5f5f5",
                                border: "1px solid #ddd",
                              }}
                              colSpan="2"
                            >
                              Zone Name: {zone?.zone_name}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            <tr>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  padding: "8px",
                                  border: "1px solid #ddd",
                                }}
                              >
                                Joining Fee
                              </td>
                              <td
                                style={{
                                  padding: "8px",
                                  border: "1px solid #ddd",
                                }}
                              >
                                {zone?.joining_fee || 0}
                              </td>
                            </tr>
                          }
                          {
                            <tr>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  padding: "8px",
                                  border: "1px solid #ddd",
                                }}
                              >
                                Joining Bonus
                              </td>
                              <td
                                style={{
                                  padding: "8px",
                                  border: "1px solid #ddd",
                                }}
                              >
                                {zone?.joining_bonus_details?.bonus_amount ||
                                  "N/A"}
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  ))}
                </tbody>
              </table>
            </Box>
          </>
        )}
      </FlexContainer>
      <CallLogsModal
        showModal={showModal}
        handleClose={handleClose}
        modalContent={modalContent}
      />
    </div>
  );
};

const tableKeyStyle = {
  borderBottom: "1px solid #ddd",
  padding: "8px",
  fontWeight: "bold",
  width: "40%",
  fontSize: "13px",
};

const tableValueStyle = {
  borderBottom: "1px solid #ddd",
  padding: "8px",
  width: "60%",
  fontSize: "15px",
};

export default OnboardingDetails;
